<template>
  <div class="box">
    <navBar :tabIndex="99" :showLogo="false"></navBar>
    <div :class="type == 1 ? 'boxIt' : 'boxhomeIt'"></div>
    <!-- <div class="topItem">
      <div class="topShit">
        <div style="color: #8a8a8a; cursor: pointer" @click="toMain">首页</div>
        <img class="topR" src="@/assets/right-icon.png" alt="" />
        <div
          style="color: #ac6f2c"
          :style="{
            'font-size': $px2rem(`${14}px`),
          }"
        >
          始祖纪念馆
        </div>
      </div>
    </div> -->
    <div style="cursor: pointer; position: relative">
      <img src="@/assets/new/founderBg.png" alt="" class="bgImg" srcset="" />
      <div class="click-bg" @click="onAdd"></div>
    </div>
    <loading-gif
      v-if="loading && moList.length === 0"
      title="正在努力加载中..."
    ></loading-gif>

    <div class="moIt" v-else>
      <div v-if="moList.length">
        <div
          class="moItem"
          v-for="(item, index) in moList"
          :key="index"
          @click.stop="toWorship(item)"
          :style="{
            height: type == 1 ? $px2rem(`${200}px`) : $px2rem(`${234}px`),
          }"
        >
          <div style="position: relative; margin-right: 28px">
            <img
              :src="item.picture ? item.picture : item.spiritTabletUrl"
              class="moImg"
              alt=""
              srcset=""
              :style="{
                'object-fit': item.picture ? 'cover' : 'contain',
                border: item.spiritTabletUrl ? '1px solid #EAAC49' : 'none',
              }"
            />
          </div>
          <div>
            <div
              style="
                color: #323232;
                font-weight: 600;
                text-align: left;
                display: flex;
                line-height: 40px;
                align-items: center;
                
              "
              :style="{
                'font-size': $px2rem(`${20}px`),
                'margin-bottom': $px2rem(`${2}px`),
              }"
            >
              {{
                item.name && item.name.length > 5
                  ? item.name.substring(0, 5)
                  : item.name
              }}

              <!-- <span style="color: #323232; font-size: 16px; padding-left: 13px"
                >(公元前1069年-公元前992年)</span> -->
              <img
                src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/fireIcon.png"
                alt=""
                style="margin-left: 10px"
                v-if="item.isHot == 1"
                class="fireIcon"
              />
              <!-- <div v-if="isShow"> -->
              <!-- <span class="follow">+关注 </span> -->

              <div
                class="follow"
                @click.stop="focusHall(item)"
                :style="{
                  'background-color': item.actionStat.isFocus
                    ? '#C9DDDD'
                    : '#387773',
                  color: item.actionStat.isFocus ? '#387773' : '#FFFFFF',
                }"
              >
                {{ item.actionStat.isFocus ? "已关注" : "+关注" }}
              </div>

              <!-- </div> -->

              <!-- <span class="follow">已关注 </span> -->
              <!-- <span></span> -->
            </div>
            <div class="remark">
              {{ item.introduction }}
            </div>

            <div class="moFlexs" style="display: flex">
              <div class="listSpan">
                <span
                  :style="{
                    'font-size': $px2rem(`${16}px`),
                    'margin-right': $px2rem(`${10}px`),
                  }"
                  >建馆时间:</span
                >
                <span :style="{ 'font-size': $px2rem(`${16}px`) }">{{
                  item.createTime.split(" ")[0]
                }}</span>
              </div>
              <div class="listSpan">
                <span
                  :style="{
                    'font-size': $px2rem(`${16}px`),
                    'margin-right': $px2rem(`${10}px`),
                  }"
                  >香火值:</span
                >
                <span :style="{ 'font-size': $px2rem(`${16}px`) }">{{
                  item.actionStat.totalSpecialCount
                }}</span>
              </div>
              <div class="listSpan">
                <span
                  :style="{
                    'font-size': $px2rem(`${16}px`),
                    'margin-right': $px2rem(`${10}px`),
                  }"
                  >留言数量:</span
                >
                <span :style="{ 'font-size': $px2rem(`${16}px`) }">{{
                  item.messageCount
                }}</span>
              </div>
              <div class="listSpan">
                <span
                  :style="{
                    'font-size': $px2rem(`${16}px`),
                    'margin-right': $px2rem(`${10}px`),
                  }"
                  >供品数量:</span
                >
                <span :style="{ 'font-size': $px2rem(`${16}px`) }">{{
                  item.giftCount
                }}</span>
              </div>
            </div>

            <div class="iconList" v-if="type == 2">
              <div
                class="iconFlex"
                v-for="(child, index) in iconList"
                :key="index"
                @click.stop="toPage(item, index)"
              >
                <img :src="child.icon" class="iconImg" alt="" srcset="" />
                <div class="iconTit">{{ child.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <none-data></none-data>
        <div class="add-hall" @click="$router.push({ path: '/venue' })">
          立即建馆
        </div>
      </div>
    </div>
    <div
      v-if="moList.length"
      :style="{
        'padding-top': $px2rem(`${43}px`),
        'padding-bottom': $px2rem(`${76}px`),
      }"
    >
      <el-pagination
        background
        layout="prev, pager, next,jumper"
        :total="total"
        @current-change="curChange"
        :current-page="pageNo"
      >
      </el-pagination>
    </div>

    <!-- 新增弹窗 -->
    <el-dialog
      title="申请始祖纪念馆"
      :visible.sync="dialogVisible"
      width="880px"
      top="112px"
      :before-close="handleClose"
    >
      <!-- 图片 -->
      <div class="form-content">
        <el-form
          class="form-content-form"
          ref="form"
          :model="form"
          :label-width="$px2rem(`${100}px`)"
          label-position="left"
        >
          <el-form-item label="照片：">
            <el-upload
              ref="upload"
              class="avatar-uploader"
              :action="action"
              :headers="header"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              accept=".png,.jpg,.jpeg"
              @mouseenter.native="mouseCover"
              @mouseleave.native="mouseOut"
            >
              <img v-if="form.picture" :src="form.picture" class="avatar" />

              <div v-else style="width: 150px; height: 150px">
                <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
                <img
                  style="width: 39px; height: 39px; margin-top: 30px"
                  src="@/assets/new/jia.png"
                  alt=""
                />
                <span style="display: block; font-size: 14px"
                  >请上传始祖照片</span
                >
              </div>
              <div class="mouse-info" v-show="showInfo">
                <img src="@/assets/upload-icon.png" />
                <div class="text">修改照片</div>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item label="逝者姓名：" required>
            <el-input
              v-model="form.name"
              maxlength="5"
              :style="{
                width: $px2rem(`${371}px`),
              }"
            ></el-input>
          </el-form-item>
          <el-form-item label="逝者性别：" required>
            <el-select
              v-model="form.sex"
              placeholder="请选择性别"
              :style="{
                width: $px2rem(`${371}px`),
              }"
            >
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期：" style="position: relative">
            <div class="mossFlex" style="position: absolute; display: flex">
              <el-date-picker
                v-model="form.birthDay"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="暂无选择"
                @change="changeDate(1)"
                :style="{
                  width: $px2rem(`${371}px`),
                }"
              >
              </el-date-picker>
              <div
                :class="!form.noBirth ? 'noMoreed' : 'noMoress'"
                @click="clearDate(1)"
              >
                不详
                <img
                  class="checkIcon"
                  src="@/assets/check-icon.png"
                  alt=""
                  v-if="form.noBirth"
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="逝世日期：">
            <div class="mossFlex" style="position: absolute; display: flex">
              <el-date-picker
                v-model="form.dieDay"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="暂无选择"
                @change="changeDate(0)"
                :style="{
                  width: $px2rem(`${371}px`),
                }"
              >
              </el-date-picker>
              <div
                :class="!form.noDie ? 'noMoreed' : 'noMoress'"
                @click="clearDate(0)"
              >
                不详
                <img
                  class="checkIcon"
                  src="@/assets/check-icon.png"
                  alt=""
                  v-if="form.noDie"
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="安葬地址：">
            <el-cascader
              v-model="form.burialAddress"
              separator=" "
              :options="options"
              :props="{
                label: 'label',
                value: 'value',
                checkStrictly: true,
                emitPath: false,
                expandTrigger: 'hover',
                children: 'children',
              }"
              :style="{
                width: $px2rem(`${371}px`),
              }"
            ></el-cascader>
          </el-form-item>
          <!-- <el-form-item label="申请理由：">
          <el-input
            v-model="form.applyReason"
            maxlength="200"
            :style="{
              width: $px2rem(`${371}px`),}"></el-input>
        </el-form-item> -->
          <el-form-item label="简介：">
            <el-input
              type="textarea"
              v-model="form.introduction"
              :style="{
                width: $px2rem(`${371}px`),
              }"
              placeholder="简介，限制150字符"
            ></el-input>
          </el-form-item>
          <el-form-item label="生平介绍：">
            <el-input
              type="textarea"
              v-model="form.remark"
              :style="{
                width: $px2rem(`${371}px`),
              }"
              placeholder="缅怀逝去的您..."
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div
              :class="{ saveBut: true, 'active-btn': isComputed }"
              @click="saveForm"
              style="cursor: pointer"
            >
              确认申请
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 提交成功 -->
    <el-dialog
      title="提交成功"
      :visible.sync="dialogsSsuccess"
      width="366px"
      :before-close="handleCloses"
    >
      <div slot="title" class="sus-title">
        <div class="title">
          <img src="@/assets/new/vectors.png" alt="" />
        </div>
        <div class="dialog-title">提交成功</div>
      </div>

      <div class="sus-describe">
        审核结果1-3个工作日将以短信方式告知您，感谢配合！
      </div>
      <div class="sus-but" @click="dialogsSsuccess = false">
        <span class="cancel">取消</span>
        <span class="confirm">确定</span>
      </div>
      <div></div>
    </el-dialog>
    <tabBar></tabBar>
  </div>
</template>

<script>
import { applyMemberHalls, getHallHuman, actionAll } from "@/api/request";
import NoneData from "@/pages/components/none-data.vue";
import LoadingGif from "@/pages/components/loadingGif.vue";
import { getToken } from "@/utils/auth";
import { toChinesNum, debounce } from "@/utils/index";
import area from "@/pages/memo/area.json";
export default {
  components: { LoadingGif, NoneData },
  data() {
    return {
      dialogVisible: false, //弹窗显示
      dialogsSsuccess: false,
      isShow: false,
      type: 3,
      loading: false,
      moList: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      iconList: [
        {
          icon: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/edit-icon.png",
          name: "修改纪念馆资料",
        },
        {
          icon: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/user-icon.png",
          name: "生平管理",
        },
        {
          icon: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/message-icon.png",
          name: "留言管理",
        },
        {
          icon: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/skin-icon.png",
          name: "风格设置",
        },
      ],
      form: {
        picture: "",
        name: "",
        sex: "",
        birthDay: "",
        dieDay: "",
        burialAddress: "",
        remark: "",
        isMember: 2,
        type: 3,
        applyReason: null,
        introduction: "",
      },
      action:
        process.env.BASE_URL.replace("subapp/sub-pc", "mmwz-app") +
        "api/video/uploadUrl",
      header: {
        Authorization: "Bearer " + getToken(),
      },
      showInfo: false,
      options: area,
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.type = this.$route.query.id;
    this.getHallHumans();
  },
  mounted() {},
  computed: {
    isComputed() {
      if (this.form.name && this.form.sex) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    focusHall(item) {
      let data = {
        bizType: 16,
        itemId: item.id,
        key: "FOCUS",
      };
      actionAll(data).then((r) => {
        if (r.data.code === 200) {
          item.actionStat.isFocus = !item.actionStat.isFocus;
        }
      });
    },
    toMain() {
      this.$router.push({ path: "/" });
    },
    getHallHumans() {
      let data = {
        // type: this.type,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        type: 3,
      };
      this.loading = true;
      getHallHuman(data).then((res) => {
        this.loading = false;
        this.moList = res.data.result.records;
        this.total = Number(res.data.result.total);
      });
    },
    curChange(e) {
      this.pageNo = e;
      this.getHallHumans();
    },
    toPage(e, i) {
      this.$router.push({ path: "/edit", query: { index: i, id: e.id } });
      // if (e.canDelete == 0 && i === 0) {
      //   return this.$message.error({
      //     showClose: true,
      //     message: "暂无权限，不可编辑！",
      //   });
      // } else {
      //   this.$router.push({ path: "/edit", query: { index: i, id: e.id } });
      // }
    },
    toWorship(e) {
      this.$router.push({ path: "/worship", query: { id: e.id } });
    },

    // 新增按钮
    onAdd() {
      console.log(1);
      if (localStorage.getItem("token")) {
      } else {
        this.$router.push("login");
      }
      localStorage.getItem("ty", 2);
      this.$router.push({ path: "/venue", query: { type: "2" } });

      // this.dialogVisible = true;
    },
    // 关闭按钮
    handleClose(done) {
      this.dialogVisible = false;
    },
    // 关闭按钮
    handleCloses(done) {
      this.dialogsSsuccess = false;
    },
    saveForm: debounce(function () {
      if (!this.form.name || !this.form.sex) {
        return;
      }
      applyMemberHalls(this.form).then((res) => {
        if (res.data.code === 200) {
          // this.$message.success("创建成功");
          this.form = {
            picture: "",
            name: "",
            sex: "",
            birthDay: "",
            dieDay: "",
            burialAddress: "",
            remark: "",
            applyReason: "",
            type: 3,
          };
          this.dialogVisible = false;
          this.dialogsSsuccess = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    }, 300),

    handleAvatarSuccess(res, file) {
      this.form.picture = res.fileName;
    },
    mouseCover() {
      if (this.form.picture) {
        setTimeout(() => {
          this.showInfo = true;
        }, 300);
      }
    },

    mouseOut() {
      if (this.form.picture) {
        setTimeout(() => {
          this.showInfo = false;
        }, 300);
      }
    },
    changeDate(e) {
      if (e == 0) {
        if (this.form.deadDay !== "") {
          this.form.noDie = false;
        }
      } else {
        if (this.form.birthDay !== "") {
          this.form.noBirth = false;
        }
      }
    },
    clearDate(e) {
      if (e == 0) {
        this.form.noDie = !this.form.noDie;
        if (this.form.noDie == true) {
          this.form.dieDay = null;
        }
      } else {
        this.form.noBirth = !this.form.noBirth;
        if (this.form.noBirth == true) {
          this.form.birthDay = null;
        }
      }
    },
  },
};
</script>
<style  lang="scss" scoped>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #579487;
  color: #fff;
}
:deep .el-dialog {
  background: #f4f5f7;
  border-radius: 10px;
}
:deep .avatar-uploader {
  text-align: left;
  margin-left: 20px;
}
:deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
:deep .avatar-uploader .el-upload:hover {
  border-color: #45796e;
}
:deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  /* height: 50px;
  line-height: 50px; */
  margin-top: 30px;
  text-align: center;
  border-radius: 5px;
}
:deep .avatar {
  width: 150px;
  height: 150px;
  display: block;
  border-radius: 10px;
  object-fit: cover;
}
</style>
<style lang="scss"  scoped>
.box {
  background: #f4f5f7;
}
.boxIt {
  /*  background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/mrMemo-bg.png")
    no-repeat;
  background-size: 100% 100%; */
  height: 1116px;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  z-index: 1;
}
.boxhomeIt {
  /*  background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/hmMemo-bg.png")
    no-repeat;
  background-size: 100% 100%; */
  height: 1116px;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  z-index: 1;
}
.bgImg {
  width: 100%;
}
.moIt {
  width: 1200px;
  min-height: 770px;
  margin: 0 auto;
  z-index: 2;
  position: relative;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
}
.topItem {
  font-size: 14px;
  z-index: 2;
  position: absolute;
  width: 1200px;
  margin: 0 auto;
  margin-top: 34px;
  left: 400px;
  top: 75px;
}
.topShit {
  display: flex;
  align-items: center;
}
.topR {
  width: 4.8px;
  height: 9px;
  flex: none;
  margin: 0 16px;
}
.add-hall {
  width: 150px;
  line-height: 46px;
  background: #e2a340;
  color: #7b3a00;
  font-size: 20px;
  font-weight: 600;
  border-radius: 9px;
  margin: 0 auto;
  cursor: pointer;
}
.moItem {
  height: 200px;
  background: url("../../assets/new/founder-bg.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  margin-bottom: 20px;
  padding: 26px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.remark {
  width: 960px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
  height: 75px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  color: #8a8a8a;
  text-align: justify;
  font-size: 14px;
}
.moItem:hover {
  filter: contrast(1.05);
}
.moImg {
  width: 150px;
  height: 150px;
  border-radius: 10px;
}
.moImgimg {
  width: 82px;
  height: 146px;
}
.mo-none-img {
  width: 150px;
  height: 150px;
  border-radius: 10px;
  border: 1px solid #eaac49;
}
.moHeat {
  position: absolute;
  bottom: 9px;
  right: 10px;
  color: #ffe8ad;
  font-size: 16px;
}
.moFlex {
  width: 400px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.listSpan {
  width: 24%;
  text-align: left;
  margin-top: 10px;
  color: #405554;
}
.moF-it {
  margin-bottom: 10px;
  line-height: 25px;
  width: 50%;
  text-align: left;
}
.iconList {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.iconFlex {
  display: flex;
  align-items: center;
  background: #eaac49;
  border-radius: 8px;
  padding: 8px 14px;
  margin-right: 12px;
}
.iconImg {
  width: 26px;
  height: 26px;
  flex: none;
  margin-right: 4px;
}
.iconTit {
  color: #7b3a00;
  font-size: 15px;
  font-weight: 500;
}
.fireIcon {
  width: 40px;
  height: 40px;
}
.follow {
  color: #405554;
  font-size: 20px;
  width: 116px;
  line-height: 38px;
  height: 38px;
  text-align: center;
  background: #c9dddd;
  display: block;
  border-radius: 20px;
  margin-left: 24px;
}

.form-content {
  display: flex;
  padding: 0 66px 0 60px;
}
.mouse-info {
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  height: 0.78125rem;
  flex-direction: column;
  align-items: center;
  width: 150px;
  padding-top: 25%;
  .text {
    font-size: 14px;
    color: #ffffff;
  }
}
.click-bg {
  width: 18%;
  height: 90px;
  position: absolute;
  top: 180px;
  left: 390px;
  z-index: 999;
  cursor: pointer;
}
.sus-title {
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #45796e1a;
    line-height: 28px;
    img {
      width: 17px;
      height: 12px;
    }
  }
  .dialog-title {
    color: #323232;
    font-size: 20px;
    font-weight: 600;
    padding-left: 10px;
  }
}
.sus-describe {
  color: #323232;
  font-size: 16px;
  margin-bottom: 20px;
}
.sus-but {
  display: flex;
  padding: 0 20px;
  cursor: pointer;
  .cancel {
    background: #f2f9f9;
    color: #575757;
    font-size: 17px;
    font-weight: 400;
    line-height: 48px;
    width: 144px;
    border-radius: 8px;
  }
  .confirm {
    background: #45796e;
    color: #ffffff;
    font-size: 17px;
    font-weight: 400;
    line-height: 48px;
    width: 144px;
    border-radius: 8px;
    margin-left: 18px;
  }
}
.noMoress {
  width: 100px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 500;
  color: #45796e;
  border-radius: 10px;
  border: 1px solid #45796e;
  margin-left: 20px;
  cursor: pointer;
  box-sizing: border-box;
}
.noMoreed {
  width: 100px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 500;
  color: #575757;
  border-radius: 10px;
  background: #ffffff;
  margin-left: 20px;
  cursor: pointer;
}
.checkIcon {
  width: 17.76px;
  height: 12.15px;
}
.saveBut {
  width: 322px;
  line-height: 50px;
  color: #fff;
  background: #c8c8c8;
  border-radius: 40px;
  text-align: center;
}
.active-btn {
  background: #45796e;
}
</style>
